<script>
import { ContactForm } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'

export default {
  mixins: [FormMixin],
  data() {
    return {
      redirectRoute: { name: 'Contact Form List' }
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Date({
          label: 'Data wysłania',
          modelPath: [this, 'form', 'created'],
          disabled: true
        }),
        new fields.Input({
          label: 'Imię i nazwisko',
          modelPath: [this, 'form', 'name'],
          disabled: true
        }),
        new fields.Input({
          label: 'E-mail',
          modelPath: [this, 'form', 'email'],
          disabled: true
        }),
        new fields.Input({
          label: 'Wiadomość',
          type: 'textarea',
          modelPath: [this, 'form', 'message'],
          autosize: { minRows: 1, maxRows: 10 },
          disabled: true
        }),
        new fields.Input({
          label: 'Adres IP',
          modelPath: [this, 'form', 'ip_address'],
          disabled: true
        }),
        new fields.Date({
          label: 'Data przesłania',
          modelPath: [this, 'form', 'notification_email_sent_at'],
          disabled: true
        }),
        new fields.Select({
          label: 'Przesłano do',
          modelPath: [this, 'form', 'notification_email_sent_to'],
          multiple: true,
          options: [],
          disabled: true,
          placeholder: ''
        }),
        new fields.Input({
          label: 'Przeglądarka',
          type: 'textarea',
          modelPath: [this, 'form', 'user_agent'],
          disabled: true,
          autosize: { minRows: 1, maxRows: 5 }
        }),
        new fields.Input({
          label: 'Treść zgody',
          type: 'textarea',
          modelPath: [this, 'form', 'agreement'],
          disabled: true,
          autosize: { minRows: 1, maxRows: 5 }
        })
      ]
    }
  },
  computed: {
    service() {
      return ContactForm
    },
    hideFormSidebar() {
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .box-wrapper {
    width: 100%;
  }
  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner,
  .el-select__tags-text {
    background-color: unset;
    color: #606266;
    cursor: default;
  }
  .submit-button,
  .language-switcher--inverse {
    display: none;
  }

  .el-form-item {
    display: flex;
    align-items: center;
    width: 100%;
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      margin-left: unset !important;
      width: 100%;
    }
  }
}
</style>
